import { LoginUserType } from "utils/Utils";
import { SiteData } from "../Data/SiteData";
import { EditorColorThemes } from "../EditorColorThemes";
import SelectDropdown from "../SelectDropdown";
import ToggleLine from "../Utilities/ToggleLine";
import {useCookies} from "react-cookie";
export const CookieIds = {
    autoSave : "vwb_autosave",
    showAddSectionButtons : "vwb_sectionbuttons",
    simplifyAdvancedSettings : "vwb_simplifyadvancedsettings",
    disableAnimations : "vwb_disableanmiations",
    editorColorScheme : "vwb_editorcolorscheme",
    autoCollapseExpandMenu:"vwb_autocollapseexpandmenu",
    autoSaveFrequency:"vwb_autosavefrequency",
    optimization:"vwb_optimization"
  }


export default function EditorSettings({siteData}:{siteData:SiteData}){
    //dont mess with cookie logic
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies();






    let date = new Date();
    date.setDate(date.getDate() + 364); //set experation date to next year

    const cookieOptions = {
        expires : date 
    }

    return(
        <>
        <div className="nice-scroll block-edit" style={{margin:"16px 8px"}}>
            <h2>Editor Preferences</h2>
      
            <ToggleLine label={"Auto Save"} description={"Automatically save your website"} toggledOn={siteData.editorSettings.autoSave} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.autoSave = on;
                setCookie(CookieIds.autoSave,on,cookieOptions);
                siteData.designer&&siteData.designer.updateAutoSaveSettings();
            }} />

            {
                siteData.editorSettings.autoSave&&
                <div className="flex-row justify-start" style={{width:"300px",marginTop:"-20px",flexShrink:"0"}}>
                   <label style={{display:"block",marginLeft:"68px",paddingRight:"2px",fontWeight:"600"}}>Auto Save Every:</label>
                <SelectDropdown  
                    options={
                    [
                        {label:"10 seconds",value:"10"},
                        {label:"30 seconds",value:"10"},
                        {label:"1 minute",  value:"60"},
                        {label:"2 minutes", value:"120"},
                        {label:"5 minutes", value:"300"},
                        {label:"10 minutes",value:"600"},
                        {label:"15 minutes",value:"900"},
                        {label:"30 minutes",value:"1800"},
                    ]
                    }
                  
                    defaultValue={siteData.editorSettings.autoSaveFrequency.toString()}
                    expandToRight={true}
                    onChange={(value:string)=>{
                        let parse = parseInt(value);
                        if(!isNaN(parse)){
                            siteData.editorSettings.autoSaveFrequency = parse;
                            setCookie(CookieIds.autoSaveFrequency,parse,cookieOptions);
                            siteData.designer&&siteData.designer.updateAutoSaveSettings();
                        }

                    }}
                    
                    />
                 
                </div>
            }
       
            {/* <ToggleLine label={"Simplify Advanced Settings"} description={"Only display advanced settings that are currently in use when editing a component"} 
            toggledOn={siteData.editorSettings.advancedMenuIsModular} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.advancedMenuIsModular = on;
                siteData.designer&&siteData.designer.forceUpdate();
                setCookie(CookieIds.simplifyAdvancedSettings,on,cookieOptions);
            }} /> */}

            <ToggleLine label={"Automatically Hide Component Menu "} description={"Automatically shows or hides the right panel when selecting a component"} toggledOn={siteData.editorSettings.autoExpandCollapseRightMenu} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.autoExpandCollapseRightMenu = on;
                setCookie(CookieIds.autoCollapseExpandMenu,on,cookieOptions);
            }} />
            <ToggleLine label={"Show New Section Buttons"} description={"Display or remove the ( + ) icon in between page sections"} toggledOn={siteData.editorSettings.showAddSectionButtons} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.showAddSectionButtons = on;
                setCookie(CookieIds.showAddSectionButtons,on,cookieOptions);
            }} />
            <ToggleLine label={"Reduced Motion"} description={"Disables most animations and may improve performance on low-end devices"} toggledOn={siteData.editorSettings.disableAnimations} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.disableAnimations = on;
                setCookie(CookieIds.disableAnimations,on,cookieOptions);
            }} />
            { siteData.userContext.userType === LoginUserType.VagaroAdmin &&
            <ToggleLine label={"Rendering Optimization (Beta)"} description={"Optimizes editor rendering but may lead to scrolling quirks"} toggledOn={siteData.editorSettings.opimizeRendering} checkRef={undefined} onChange={(on:boolean)=>{
                siteData.editorSettings.disableAnimations = on;
                (window as any).optimizevrendering = on;
                setCookie(CookieIds.optimization,on,cookieOptions);

                if(siteData.designer&&!on){
                    let layout = siteData.designer.state.layout;
                    for(let i = 0;i<layout.children.length;i++){
                        layout.children[i].inView = true;
                    }
                    siteData.designer.forceUpdate();
                }
            }} />
         }

        <div className="flex-column wb-input-group no-border ">
            <label>Editor Color Theme</label>
            <div className="flex-row gap-med" style={{paddingTop:'4px'}}>
            {
               
                EditorColorThemes.map((theme,index)=>{
                    const bg = (index==siteData.editorSettings.editColorIndex)?"#c7c7c7":"transparent";
                   return <button key={index} className="invisible-button"  style={{width:"64px",height:"64px",padding:"8px",boxShadow:"0 0 12px -4px #00000044",borderRadius:"8px",background:bg}}
                   onClick={()=>{
                          siteData.editorSettings.editColorIndex = index;
                          siteData.designer&&siteData.designer.forceUpdate();
                          setCookie(CookieIds.editorColorScheme,index,cookieOptions);
                   }}
                   >
                        <div style={{borderRadius:"50px",background:theme.primary,width:"48px",height:"48px"}}>

                        </div>
                     
                    </button>

                })
            }
</div>
            </div>

        </div>
        </>
    )




}